import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';

export interface NextStepItem {
  stepNumber: string | number;
  title: string;
  description: string;
}

@Component({
  selector: 'aura-thank-you',
  templateUrl: './thank-you.component.html',
  imports: [RouterLink],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuraThankYouComponent {
  readonly badgeText = input<string>('Demande enregistrée avec succès');
  readonly title = input<string>('Merci pour votre confiance !');
  readonly description = input<string>(
    "Votre demande a bien été transmise. Nos équipes l'analysent actuellement.",
  );
  readonly responseTimeTitle = input<string>('Engagement de réponse rapide');
  readonly responseTimeText = input<string>('Temps de réponse garanti : sous 48 heures ouvrées.');
  readonly showResponseTime = input<boolean>(true);

  readonly nextStepsTitle = input<string>('Prochaines étapes :');
  readonly nextSteps = input<NextStepItem[]>([]);

  readonly homeUrl = input<string>('/');
  readonly homeButtonText = input<string>("Retour à l'accueil");
}
